import { z } from 'zod';

export const yearsResponseSchema = z.object({
  anosLetivos: z.array(z.number().int()),
});

export type YearsResponse = z.infer<typeof yearsResponseSchema>;
